const VIEWPORT_PADDING = 8;
const DEFAULT_MIN_LIST_HEIGHT = 96;
const DEFAULT_PREFERRED_LIST_HEIGHT = 208;

/**
 * Computes fixed-position dropdown layout that stays within the viewport.
 * Flips upward when there is insufficient space below (unless placement is forced).
 */
export function computeFloatingDropdownLayout({
  triggerRect,
  preferredWidth,
  headerHeight = 72,
  gap = 4,
  minListHeight = DEFAULT_MIN_LIST_HEIGHT,
  preferredListHeight = DEFAULT_PREFERRED_LIST_HEIGHT,
  viewportPadding = VIEWPORT_PADDING,
  placement = 'auto',
} = {}) {
  if (!triggerRect) {
    return { style: {}, listMaxHeight: preferredListHeight, openUp: false };
  }

  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const width = Math.min(
    Math.max(preferredWidth ?? triggerRect.width, 260),
    viewportWidth - viewportPadding * 2
  );
  const left = Math.max(
    viewportPadding,
    Math.min(triggerRect.left, viewportWidth - viewportPadding - width)
  );

  const spaceBelow = viewportHeight - triggerRect.bottom - gap - viewportPadding;
  const spaceAbove = triggerRect.top - gap - viewportPadding;

  let openUp = false;
  if (placement === 'up') {
    openUp = true;
  } else if (placement === 'down') {
    openUp = false;
  } else {
    const preferredPanelHeight = headerHeight + preferredListHeight;
    openUp = spaceBelow < preferredPanelHeight && spaceAbove > spaceBelow;
  }

  const panelSpace = openUp ? spaceAbove : spaceBelow;
  const listMaxHeight = Math.max(
    minListHeight,
    Math.min(preferredListHeight, Math.max(0, panelSpace - headerHeight))
  );

  if (openUp) {
    return {
      style: {
        position: 'fixed',
        bottom: viewportHeight - triggerRect.top + gap,
        left,
        width,
        zIndex: 9999,
      },
      listMaxHeight,
      openUp: true,
    };
  }

  return {
    style: {
      position: 'fixed',
      top: triggerRect.bottom + gap,
      left,
      width,
      zIndex: 9999,
    },
    listMaxHeight,
    openUp: false,
  };
}

export default computeFloatingDropdownLayout;
